import { render, staticRenderFns } from "./CampaignDetailHeader.vue?vue&type=template&id=76a673d0&"
import script from "./CampaignDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./CampaignDetailHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports